import * as React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import logo from '../../Assets/Images/logo.png';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import '../Layout/style.css';
import { Outlet, useLocation, useNavigate } from 'react-router';
import { useErrorHandler } from '../../hooks';
import { useDispatch } from 'react-redux';
import { LogoutAction } from '../../Redux/Actions/AuthActions';
import { doctorRoutes, adminRoutes, editorRoutes, doctorEditorRoutes, researcherRoutes } from '../../Routes';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Collapse, Divider } from '@mui/material';

const drawerWidth = 240;

function Layout(props) {
  const { user } = useSelector((state) => state?.Auth);
  const { severity, message } = useSelector((state) => state.Toast);
  const { window } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { setMsgConfig } = useErrorHandler();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const userData = JSON.parse(localStorage.getItem('userData'));

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  function handleClick() {
    setOpen(!open);
  }

  const handleLogout = () => {
    dispatch(LogoutAction());
    setMsgConfig({
      alertOpen: true,
      message: message,
      severity: severity,
      autoHideDuration: 1000,
    });
    navigate('/login');
  };
  const pathName = useLocation().pathname;
  const drawer = (
    <Box className="d-sidebar">
      <Box className="Dashboard-logo">
        <img src={logo} className="brand-logo"></img>
      </Box>
      <List className="list-item">
        {user?.role === 'admin' || userData?.role === 'admin'
          ? adminRoutes.map((route, index) => {
              if (route.isSideKey) {
                return (
                  <ListItem
                    key={route.name}
                    disablePadding
                    className={
                      pathName.includes(route.path) ? `activeSidebar` : ''
                    }
                    component={Link}
                    to={route.path}
                  >
                    <ListItemButton
                      className="d-button"
                      onClick={route.isSubmenu ? handleClick : null}
                    >
                      <ListItemIcon className="d-icon">
                        {route?.icon}
                      </ListItemIcon>
                      <ListItemText
                        className="sidebar-menu"
                        primary={route.name}
                      />
                      {route.isSubmenu ? (
                        open ? (
                          <ExpandLessIcon className="expandicon" />
                        ) : (
                          <ExpandMoreIcon />
                        )
                      ) : (
                        ''
                      )}
                    </ListItemButton>
                    {route.isSubmenu ? (
                      <Collapse
                        className="collapasemenu"
                        in={open}
                        timeout="auto"
                        unmountOnExit
                      >
                        <List component="div" disablePadding>
                          {route.isSubmenu
                            ? route.subMenu.map((menu) => {
                                return (
                                  <ListItem
                                    className="collapasesubmenu"
                                    key={menu.name}
                                    disablePadding
                                    component={Link}
                                    to={menu.path}
                                  >
                                    <ListItemText inset primary={menu.name} />
                                  </ListItem>
                                );
                              })
                            : ''}
                        </List>
                      </Collapse>
                    ) : (
                      ''
                    )}
                  </ListItem>
                );
              }
              return;
            })
          : (user?.role === 'doctor' || userData?.role === 'doctor') && (user?.is_editor === false || userData?.is_editor === false)? doctorRoutes.map((route, index) => {
              if (route.isSideKey) {
                return (
                  <ListItem
                    className="collapasesubmenu"
                    key={route.name}
                    disablePadding
                    component={Link}
                    to={route.path}
                  >
                    <ListItemButton className="d-button">
                      <ListItemIcon className="d-icon">
                        {route?.icon}
                      </ListItemIcon>
                      <ListItemText
                        className="sidebar-menu"
                        primary={route.name}
                      />
                    </ListItemButton>
                  </ListItem>
                );
              }
            })
          : (user?.role === 'doctor' || userData?.role === 'doctor') && (user?.is_editor === true || userData?.is_editor === true)          
          ?
          doctorEditorRoutes.map((route, index) => {
          
              if (route.isSideKey) {
                return (
                  <ListItem
                    className="collapasesubmenu"
                    key={route.name}
                    disablePadding
                    component={Link}
                    to={route.path}
                  >
                    <ListItemButton className="d-button">
                      <ListItemIcon className="d-icon">
                        {route?.icon}
                      </ListItemIcon>
                      <ListItemText
                        className="sidebar-menu"
                        primary={route.name}
                      />
                    </ListItemButton>
                  </ListItem>
                );
              }
            }) : (user?.role === 'researcher' || userData?.role === 'researcher') ?
            researcherRoutes?.map((route, index) => {
              if (route.isSideKey) {
                return (
                  <ListItem
                    className="collapasesubmenu"
                    key={route.name}
                    disablePadding
                    component={Link}
                    to={route.path}
                  >
                    <ListItemButton className="d-button">
                      <ListItemIcon className="d-icon">
                        {route?.icon}
                      </ListItemIcon>
                      <ListItemText
                        className="sidebar-menu"
                        primary={route.name}
                      />
                    </ListItemButton>
                  </ListItem>
                );
              }
            })
            :
            editorRoutes.map((route, index) => {
              if (route.isSideKey) {
                return (
                  <ListItem
                    className="collapasesubmenu"
                    key={route.name}
                    disablePadding
                    component={Link}
                    to={route.path}
                  >
                    <ListItemButton className="d-button">
                      <ListItemIcon className="d-icon">
                        {route?.icon}
                      </ListItemIcon>
                      <ListItemText
                        className="sidebar-menu"
                        primary={route.name}
                      />
                    </ListItemButton>
                  </ListItem>
                );
              }
            })
            }
        <ListItem disablePadding onClick={() => handleLogout()}>
          <ListItemButton className="d-button">
            <ListItemIcon className="d-icon">
              <LogoutIcon />
            </ListItemIcon>
            <ListItemText primary="LOGOUT" />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar
        className="d-appbar"
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
        }}
      >
        <Toolbar
          sx={{ backgroundColor: '#51B6FC', color: '#ffffff' }}
          className="d-header"
        >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          {user?.role === 'admin' || userData?.role === 'admin'
            ? adminRoutes?.map((route, index) => {
                if (route.isSideKey) {
                  return pathName.includes(route.path) ? (
                    <Typography
                      key={route.name}
                      variant="h6"
                      sx={{ flexGrow: 1 }}
                    >
                      {route.name}
                    </Typography>
                  ) : (
                    ''
                  );
                }
                return;
              })
            : (user?.role === 'doctor' || userData?.role === 'doctor') && (user?.is_editor === false || userData?.is_editor === false)? 
            doctorRoutes?.map((route, index) => {
                if (route.isSideKey) {
                  return pathName.includes(route.path) ? (
                    <Typography
                      key={route.name}
                      variant="h6"
                      sx={{ flexGrow: 1 }}
                    >
                      {route.name}
                    </Typography>
                  ) : (
                    ''
                  );
                }
                return;
              })
              :
              (user?.role === 'doctor' || userData?.role === 'doctor') && (user?.is_editor === true || userData?.is_editor === true)?
              doctorEditorRoutes?.map((route, index) => {
                if (route.isSideKey) {
                  return pathName.includes(route.path) ? (
                    <Typography
                      key={route.name}
                      variant="h6"
                      sx={{ flexGrow: 1 }}
                    >
                      {route.name}
                    </Typography>
                  ) : (
                    ''
                  );
                }
                return;
              })
               :  (user?.role === 'researcher' || userData?.role === 'researcher') ?
               researcherRoutes?.map((route, index) => {
                if (route.isSideKey) {
                  return pathName.includes(route.path) ? (
                    <Typography
                      key={route.name}
                      variant="h6"
                      sx={{ flexGrow: 1 }}
                    >
                      {route.name}
                    </Typography>
                  ): (
                    ''
                  );
                }
                return;
              })
               :
               editorRoutes?.map((route, index) => {
                if (route.isSideKey) {
                  return pathName.includes(route.path) ? (
                    <Typography
                      key={route.name}
                      variant="h6"
                      sx={{ flexGrow: 1 }}
                    >
                      {route.name}
                    </Typography>
                  ) : (
                    ''
                  );
                }
                return;
              })
               }
          {user?.role === 'doctor' || userData?.role === 'doctor' || user?.role === 'editor' || userData?.role === 'editor' || user?.role === 'researcher' || userData?.role === 'researcher' ? (
            <AccountCircleIcon
              size="large"
              edge="start"
              color={'#000000'}
              aria-label="menu"
              sx={{ mr: 1 }}
            />
          ) : (
            <AdminPanelSettingsIcon
              size="large"
              edge="start"
              color={'#000000'}
              aria-label="menu"
              sx={{ mr: 1 }}
            />
          )}
          <Typography variant="h6" sx={{ flexGrow: 0 }}>
            {user?.role === 'doctor' || userData?.role === 'doctor'
              ? `Dr.${userData?.first_name || user?.first_name} ${
                  userData?.last_name || user?.last_name
                }`
              : user?.role === 'admin' || userData?.role === 'admin' ? 'Admin' : user?.role === 'researcher' || userData?.role === 'researcher' ? 'Researcher' : 'Editor'}
          </Typography>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        className="d-main"
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        <Toolbar />
        <Box className="main-Dashbord">
          {props.children}
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}

Layout.propTypes = {
  window: PropTypes.func,
};

export default Layout;
